import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

const LpzChart = ({ data = [], title = 'LPZ Rating Progression' }) => {
  const chartData = [...data]
    .filter(match => match.player_lpz != null)
    .reverse() // API returns DESC (latest first); chart needs oldest first
    .map(match => ({
      match: match.match_number,
      lpz: match.player_lpz,
      opponent: match.opponent,
      date: match.date,
      lpzChange: match.lpz_change,
    }))

  if (chartData.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
        <div className="h-64 flex items-center justify-center text-gray-500">
          No LPZ data available
        </div>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="match"
              axisLine={false}
              tickLine={true}
              tick={false}
            />
            <YAxis domain={['auto', 'auto']} />
            <Tooltip
              formatter={(value, name, props) => {
                const { lpzChange } = props.payload
                const changeStr = lpzChange != null
                  ? (lpzChange > 0 ? ` (+${lpzChange})` : ` (${lpzChange})`)
                  : ''
                return [`${value}${changeStr}`, 'LPZ']
              }}
              labelFormatter={(label, payload) => {
                if (payload && payload[0]) {
                  const { opponent, date } = payload[0].payload
                  return `${opponent} — ${date}`
                }
                return `Match ${label}`
              }}
            />
            <Line
              type="monotone"
              dataKey="lpz"
              stroke="#3b82f6"
              strokeWidth={2}
              dot={{ fill: '#3b82f6', r: 2 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default LpzChart
